export const baseUrl = "https://tripolo-backend.vercel.app"
// export const baseUrl = "http://localhost:8080"